import { AnnotationDotFragment } from '@sketch/gql-types'

/**
 * The UUID of the entity an annotation is pinned to, or null when it sits on
 * the page itself.
 *
 * A Frame- or Section-subject annotation falls back to a backfilled Page
 * subject once the frame/Section it was pinned to no longer exists, but keeps
 * the UUID - which is what makes it distinguishable from an annotation genuinely
 * placed on the page. The frame wins over the Section for an annotation pinned
 * inside one: it's the entity the dot is drawn against.
 */
export const getAnnotationAnchorUUID = (annotation: AnnotationDotFragment) =>
  annotation.currentSubject.__typename === 'Artboard'
    ? annotation.currentSubject.uuid
    : (annotation.frameUuid ?? annotation.sectionUuid ?? null)

/** Whether the annotation belongs to the page being viewed. */
export const isAnnotationOnPage = (
  annotation: AnnotationDotFragment,
  permanentPageId: string
) => {
  const { currentSubject } = annotation

  if (currentSubject.__typename === 'Artboard') {
    return currentSubject.page?.uuid === permanentPageId
  }

  if (currentSubject.__typename === 'Page') {
    return currentSubject.pageUUID === permanentPageId
  }

  return false
}
